import { createContext, useContext, useEffect, useState } from "react";
import { CONTENT } from "@/content";

const LangCtx = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("ev-lang") || "ro");
  useEffect(() => {
    localStorage.setItem("ev-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  return <LangCtx.Provider value={{ lang, setLang, t: CONTENT[lang] }}>{children}</LangCtx.Provider>;
};

export const useLang = () => useContext(LangCtx);

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};
